import { render } from "./NavigationBottom.vue?vue&type=template&id=2a80b615"
import script from "./NavigationBottom.vue?vue&type=script&lang=js"
export * from "./NavigationBottom.vue?vue&type=script&lang=js"

import "./NavigationBottom.vue?vue&type=style&index=0&id=2a80b615&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__